import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'quasar/src/utils/debounce.js';;
export default {
  name: "TextInput",
  props: {
    static: {
      type: Boolean,
      default: false
    },
    reverseFill: {
      type: Boolean,
      default: false
    },
    fillMask: {},
    disable: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    neverReadOnly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    searchInput: {
      type: Boolean,
      default: false
    },
    standout: {
      type: Boolean,
      default: false
    },
    readOnly: {
      default: false
    },
    borderless: {
      default: false
    },
    forceBorderless: {
      default: false
    },
    inverted: {
      default: false
    },
    rules: {},
    label: {
      type: String
    },
    value: {},
    mask: {
      type: String
    },
    fillmask: {
      type: String
    },
    suffix: {
      type: String
    },
    prefix: {
      type: String,
      default: null
    },
    outlined: {
      type: Boolean,
      default: true
    },
    filled: {
      type: Boolean
    },
    color: {
      type: String,
      default: "blue"
    },
    BGColor: {
      type: String,
      default: "white"
    },
    size: {
      type: String,
      default: "10px"
    },
    dense: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    hasMaxLength: {
      type: Boolean,
      default: false
    },
    maxLength: {},
    autogrow: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean
    },
    tooltip: {
      type: Boolean
    },
    toolValue: {
      type: String
    },
    hint: {
      type: String
    },
    inputStyle: {
      type: String,
      default: "padding-bottom:0px;"
    },
    required: {
      type: Boolean,
      default: false
    },
    errorValidation: {
      type: Boolean
    },
    showMenuDropDown: {
      default: false
    },
    min: {},
    max: {},
    step: {},
    clickToEdit: {
      default: false
    },
    allowDebounce: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      clicked: false,
      originalValue: null
    };
  },
  computed: {
    isOutlined: function isOutlined() {
      if (this.forceBorderless) {
        return false;
      }

      if (this.readOnly) {
        return true;
      } else return this.outlined;
    },
    isBorderless: function isBorderless() {
      if (this.readOnly) {
        return false;
      } else return this.borderless;
    },
    hasError: function hasError() {
      return this.$refs.input.hasError;
    },
    isDirty: function isDirty() {
      return this.value != "" && this.value != null && this.value != this.originalValue;
    }
  },
  mounted: function mounted() {
    if (this.allowDebounce) this.emitValue = debounce(this.emitValue, 100);
    this.originalValue = this.value;
  },
  methods: {
    emitValue: function emitValue($event) {
      if (this.type == "number") {
        if ($event.target.value == null) this.$emit("input", $event.target.value);else this.$emit("input", Number($event.target.value));
      } else {
        this.$emit("input", $event.target.value);
      }
    },
    isRequired: function isRequired() {
      if (this.required) {
        if (this.value == null || this.value === "") return "*Field is required";else return true;
      } else return true;
    },
    exceedsMaxLength: function exceedsMaxLength() {
      if (this.hasMaxLength) {
        if (this.value.length > this.maxLength) return "Text cannot exceed " + this.maxLength + " characters.";else return true;
      } else return true;
    },
    validate: function validate() {
      return this.$refs.input.validate();
    },
    resetDirty: function resetDirty() {
      this.originalValue = this.value;
      if (this.$refs.input) this.$refs.input.isDirty = false;
    }
  }
};